import React, { createContext, useContext } from "react";
import { Toaster } from 'react-hot-toast';
import { useSelector } from "react-redux";
import { RootState } from "../state/reducers/rootReducer";

type CommonContextType = {
    children: React.ReactNode
}

type CommonStoreType = {
    checkAccesiableTo: (path: string, httpMethod: "GET" | "POST" | "PUT" | "DELETE") => boolean,
    createUUID: () => string,
    translate: (code: string) => string
}

const CommonContext = createContext({} as CommonStoreType);
const useCommonContext = () => useContext(CommonContext)
const CommonProvider = ({ children }: CommonContextType) => {
    const user = useSelector((state: RootState) => state.auth.user)
    const store: CommonStoreType = {

        checkAccesiableTo: (path: string, httpMethod: "GET" | "POST" | "PUT" | "DELETE") => {
            return true;
            // const api = user.apis.filter(x => x.method === httpMethod).find(x => x.url === path || x.url === `api/${path}`);
            // console.log({
            //     api
            // });

            // if (api) return true;
            // return false;
        },
        createUUID: () => {
            return "";
            // return uuidv4();
        },
        // translate: (vi: string) => {
        //     return vi;
        // },
        translate: (code: string) => {
            return code;
            // if (code == "MappingFormulaForm.Max.Item.OffsetLabel.HelpText") {
            //     return localized_resources.get(code) ?? "xxx";
            // }
            // return localized_resources.get(code) ?? code;
        }

    }
    return (
        <CommonContext.Provider value={store}>
            {children}
            {/* <ToastContainer /> */}
            <Toaster
                toastOptions={{
                    success: {
                        style: {
                            background: '#1B7F36',
                            color: "#fff"
                        },
                    },
                    error: {
                        style: {
                            background: '#A30F26',
                            color: "#fff"

                        },
                    },
                    position: "bottom-right"
                }}
            />
        </CommonContext.Provider>
    );
}
export {
    CommonProvider,
    useCommonContext
};

